import Validation from '../lib/validation'

function validate(data, type) {
  const validator = new Validation(data)
  switch (type) {
    case 'update': {
      validator.isRequired('_id', 'ID lokace je při editaci povinné.')
      validator.isObjectId('_id', 'ID lokace není ve správném formátu.')
    }
    // no default
  }
  validator.isRequired('name', 'Název lokace je povinný.')
  return validator.validate()
}

export const validateCreate = (data) => validate(data, 'create')
export const validateUpdate = (data) => validate(data, 'update')

export default validate



// WEBPACK FOOTER //
// ./src/common/locations/validations.js